<template>
  <div class="care-record">
    <div class="service-name">服务记录</div>
    <div class="records">
      <div v-if="records && records.length === 0" class="no-record">
        <img src="@/assets/s-form-tjzl.png" /><i>无服务记录</i>
      </div>
      <div
        v-else
        class="item"
        v-for="(item, index) in records"
        :key="'record' + index"
      >
        <div class="name">
          <span class="num">1</span>
          <span>使用(次)</span>
        </div>
        <div class="time">
          <span class="title">{{item.name || '未知'}}</span>
          <!-- <span>剩余可使用1张，共{{item.total}}次</span> -->
          <span>{{ new Date(item.time && (item.time +"+08:00")).format("yyyy-MM-dd hh:mm") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { httpOpen } from "../../scripts/network";
export default {
  name: "CareRecord",
  data() {
    return {
      type: -1,
      name:'',
      records: []
    };
  },
    watch: {
      name(value) {
        document.title = value
      }
    },
  created(){
    this.id = this.$route.params.id;
    this.loadData();
  },
  methods:{
    async loadData(){
      try {
          this.$loading.show()
       const ret = await httpOpen("/WuYouCard/GetServiceOrderRecords",{
          type:"post",
          body:{
            CardSysNo:this.id
          }
        })
        if (ret.Status){
             this.type = ret.Data.ServiceType;
             this.name = ret.Data.ServiceTypeName;
             this.records = ret.Data.OrderEquityList ? ret.Data.OrderEquityList.map(item => {
               return {
                 name: item.EquityTypeName,
                 time: item.CompleteTime,
                 use:item.UseTotalNum,
                 total:item.EquityTotalCount
               }
             }) : []
        }else{
          this.$toast("加载失败")
        }
        console.log(ret)
      } catch (e) {
        console.error(e)
      } finally {
          this.$loading.hide()
      }
    },
  }
};
</script>

<style lang="less">
.care-record {
  min-height: 100vh;
  overflow: hidden;
  font-size: 14px;
  font-weight: 500;
  background-color: #f4f4f4;
  .no-record{
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: black;
    background-color: #fff;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img{
      width: 68px;
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
      margin-bottom: 27px;
    }
    i{
      font-style: normal;
      font-size: 17px;
      font-weight: 600;
    }
  }
  .service-name{
    width: 100%;
    padding: 13px 18px;
    box-sizing: border-box;
    font-size: 15px;
    font-weight: 600;
  }
  .bg {
    position: fixed;
    z-index: -1;
    text-align: center;
    width: 100%;
    height: 100vh;
    img {
      height: 14px;
      margin-top: 25px;
    }
    
    &,&[type="10"] {
      background: linear-gradient(
        to bottom,
        #e9f5ff 0%,
        #f1f5f8 40%,
        #f1f5f8 100%
      );
    }
    &[type="20"] {
      background: linear-gradient(
        to bottom,
        #f1e0ba 0%,
        #f1f5f8 40%,
        #f1f5f8 100%
      );
    }
  }

  .records {
    padding: 0 16px;
    .item {
      background: white;
      border-radius: 6px;
      display: flex;
      align-items: center;
      .name{
        display: flex;
        flex-direction: column;
        text-align: center;
        color: #5C5C5C;
        padding: 20px 30px;
        position: relative;
        &:before{
          content: '';
          position: absolute;
          top:20px;
          right: 0;
          width: 1px;
          bottom: 20px;
          background-color: #D9D9D9;
        }
        .num{
          font-size: 35px;
          font-weight: 600;
          color: #000;
        }
      }
      .time {
        font-size: 12px;
        color: #666666;
        display: flex;
        flex-direction: column;
        line-height: 1.5;
        padding: 20px 30px;
        position: relative;
        &:before{
          content: '';
          position: absolute;
          top:-10px;
          left: -10px;
          width: 20px;
          height: 20px;
          border-radius: 100%;
          background-color: #f4f4f4;
        }
        &:after{
          content: '';
          position: absolute;
          bottom:-10px;
          left: -10px;
          width: 20px;
          height: 20px;
          border-radius: 100%;
          background-color: #f4f4f4;
        }
        .title{
          font-size: 17px;
          color: #000;
          font-weight: 600;
        }
      }
    }
    .item + .item {
      margin-top: 16px;
    }
  }
}
</style>